import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import useFetchNews from "./useFetchNews";
import { Swiper, SwiperSlide } from "swiper/react";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import "swiper/css";
import MotionReveal from "../motion/MotionReveal";

const Service = () => {
  const postService = useFetchNews("dịch vụ");
  const [cardsVisible, setCardsVisible] = useState(false);
  const { ref: sectionRef, inView: sectionInView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
    rootMargin: "0px 0px -16% 0px",
  });

  useEffect(() => {
    if (!sectionInView) return;

    const timer = window.setTimeout(() => {
      setCardsVisible(true);
    }, 140);

    return () => window.clearTimeout(timer);
  }, [sectionInView]);

  return (
    <section className="relative overflow-hidden py-8 md:py-14">
      <div
        className="pointer-events-none absolute inset-x-0 top-[118px] h-[360px] bg-slate-100 max-md:inset-0 max-md:h-full"
        aria-hidden="true"
      />
      <div ref={sectionRef} className="relative w-full overflow-hidden pl-4 md:pl-8 xl:pl-12">
        <MotionReveal direction="up" delay={0.18} amount={0.08}>
          <div className="px-4 pb-6 text-center md:hidden">
            <h2 className="section-tech-title text-[24px] font-bold text-[#084FA8]">
              Dịch vụ - hạ tầng
            </h2>
            <p className="mt-4 text-base leading-8 text-[#4f5661]">
              VNPT Net cung cấp hệ sinh thái hạ tầng số toàn diện với các dịch vụ Internet, truyền dẫn, VPN và trung tâm dữ liệu, mang đến kết nối mạnh mẽ, ổn định và an toàn.
            </p>
          </div>
        </MotionReveal>

        <MotionReveal direction="up" delay={0.18} amount={0.08}>
          <Swiper
            spaceBetween={16}
            slidesPerView={"auto"}
            className="service-track !overflow-visible"
          >
            <SwiperSlide className="!hidden !h-auto md:!block">
              <div
                className={`h-full transform-gpu transition-all duration-700 ease-out ${
                  cardsVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
                }`}
              >
                <div className="flex h-full min-h-[440px] flex-col justify-center px-7 py-10 md:px-10 md:py-14">
                  <div>
                    <h2 className="section-tech-title text-[24px] md:text-[32px] lg:text-[44px] font-bold text-[#084FA8]">
                      Dịch vụ - hạ tầng
                    </h2>
                    <p className="mt-7 text-[17px] leading-9 text-[#4f5661] md:text-[18px]">
                      VNPT Net cung cấp hệ sinh thái hạ tầng số toàn diện với các dịch vụ Internet, truyền dẫn, VPN và trung tâm dữ liệu, mang đến kết nối mạnh mẽ, ổn định và an toàn.
                    </p>
                  </div>

                  <div className="mt-8 inline-flex items-center gap-3 text-sm font-semibold uppercase tracking-[0.08em] text-[#9aa0a9]">
                    <span>Xem tất cả dịch vụ</span>
                    <ArrowRight className="h-4 w-4" strokeWidth={2.2} />
                  </div>
                </div>
              </div>
            </SwiperSlide>

            {postService?.map((item, index) => (
              <SwiperSlide key={item.id || index} className="!h-auto">
                <div
                  className={`h-full transform-gpu transition-all duration-700 ease-out ${
                    cardsVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
                  }`}
                  style={{ transitionDelay: `${140 + (index + 1) * 70}ms` }}
                >
                  <Link
                    to={`/dich-vu-ha-tang/${item.id}`}
                    className="group relative flex h-full min-h-[470px] flex-col overflow-hidden border border-gray-100 border-b-[3px] border-b-[#0a6fd6] bg-white px-5 pb-5 pt-5 shadow-md transition-[box-shadow] duration-300 max-md:min-h-0"
                  >
                    <span className="pointer-events-none absolute inset-x-0 bottom-0 z-0 h-0 bg-[linear-gradient(180deg,#1c8bfb_0%,#0a6fd6_65%,#0753a1_100%)] transition-[height] duration-500 ease-out group-hover:h-full" />

                    <h3 className="relative z-[1] min-h-[64px] text-[24px] font-bold uppercase leading-[1.16] tracking-[-0.03em] text-[#146ef1] transition-colors duration-300 group-hover:text-white max-md:min-h-[52px] max-md:text-[18px] max-md:leading-[1.22]">
                      {item.title}
                    </h3>

                    <div className="relative z-[1] mt-3 overflow-hidden rounded-[16px] bg-[#eef3f8] shadow-[inset_0_0_0_2px_rgba(255,255,255,0.82)] transition-all duration-300 group-hover:shadow-[inset_0_0_0_4px_rgba(255,255,255,0.98)] border border-white/80">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="aspect-video w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
                      />
                      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-[#041836]/12 to-transparent transition-opacity duration-300 group-hover:opacity-60" />
                    </div>

                    <div className="relative z-[1] mt-4 flex flex-1 flex-col">
                      <p className="line-clamp-2 text-[14px] leading-8 text-[#64748b] transition-colors duration-300 group-hover:text-white">
                        {item.description}
                      </p>

                      <div className="mt-5 inline-flex items-center gap-2 self-start rounded-full bg-[#eef5fd] px-3 py-1.5 text-sm font-semibold text-[#0a6fd6] transition-all duration-300 group-hover:bg-white/18 group-hover:text-[#0a6fd6]">
                        Xem chi tiết
                        <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-white text-[#0a6fd6] shadow-[0_4px_10px_rgba(10,111,214,0.12)] transition-all duration-300 group-hover:translate-x-0.5 group-hover:bg-white group-hover:text-[#0a6fd6]">
                          <ArrowUpRight className="h-4 w-4" strokeWidth={2.3} />
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </MotionReveal>
      </div>

      <style>{`
        .service-track .swiper-wrapper {
          align-items: stretch;
        }

        .service-track .swiper-slide {
          height: auto;
          display: flex;
          width: min(390px, calc(100vw - 5.5rem));
        }

        .service-track .swiper-slide:first-child {
          width: min(540px, calc(100vw - 5.5rem));
        }

        @media (max-width: 959px) {
          .service-track {
            padding-left: 0.15rem;
          }

          .service-track .swiper-slide,
          .service-track .swiper-slide:first-child {
            width: min(290px, calc(100vw - 7.5rem));
          }
        }
      `}</style>
    </section>
  );
};

export default Service;
